
import Modal from "components/Models/index";
import useScreenMobile from "hooks/useScreen";
import React, { useState } from "react";
import "./team.scss";
import Drawer from "components/Drawer/index";
import CreateTeam from "./CreateTeam/index";
import TeamAssignAccess from "./TeamAssignAccess/index";
import { Team as izTeam } from "@induz/sdk";
import { useToast } from "components/Toaster/index";

const TeamContent = ({ onAddRole, handleCancel }) => {
  const [step, setStep] = useState("team");
  const [roleData, setRoleData] = useState({
    roleName: "",
    operations: []
  });
  const showToast = useToast();

  const handleNextStep = () => setStep("access");

  const updateTeamName = (name) => {
    setRoleData((prev) => ({ ...prev, roleName: name }));
  };

  const updateOperations = (operations) => {
    setRoleData((prev) => ({ ...prev, operations }));
  };

  const handleSubmit = async () => {
    // Remove all spaces from team name and convert to lowercase to match backend storage
    // This ensures consistency when creating and deleting teams
    const trimmedTeamName = roleData.roleName.replace(/\s+/g, "").toLowerCase();
    
    const newRole = {
      roles: trimmedTeamName,
      operations: roleData.operations.map((op) => op.role)
    };
    
    try {
      await izTeam.addTeam(newRole.roles, newRole.operations);
      showToast("Team added successfully", "success");
      onAddRole(newRole);
      
    } catch (error) {
      showToast("Failed to add team", "error");
      console.error("Error adding team:", error);
    }

    // Comment: This calls onAddRole, which will handle API creation in ManageTeam
    handleCancel();
  };

  return (
    <div className="Team">
      <div className="TeamTop">
        <h1>Create a Team</h1>
        <p className="text">
          {step === "access"
            ? "Create a team roles"
            : "Enter a name for your new team"}
        </p>
        <div className="TeamStepper">
          <div
            className="Teamsteps first"
            onClick={() => {
              if (step === "access") setStep("team");
            }}
            style={{ cursor: step === "access" ? "pointer" : "default" }}
          >
            <div className="step">
              <span>1</span>
            </div>
            <p>Create Team</p>
          </div>
          <span className="TeamStepperLine"></span>
          <div
            className={`Teamsteps ${step === "access" ? "first" : ""}`}
            onClick={() => {
              if (step === "access") setStep("access");
            }}
            style={{ cursor: roleData.roleName ? "pointer" : "not-allowed" }}
          >
            <div className="step">
              <span>2</span>
            </div>
            <p>Assign Access</p>
          </div>
        </div>
      </div>
      {step === "access" ? (
        <TeamAssignAccess
          updateOperations={updateOperations}
          roleData={roleData}
          handleSubmit={handleSubmit}
          handleCancel={handleCancel}
        />
      ) : (
        <CreateTeam
          handleNextStep={handleNextStep}
          updateRoleName={updateTeamName}
          initialRoleName={roleData.roleName}
        />
      )}
    </div>
  );
};

function Team({ handleCancel, onAddRole }) {
  const isMobile = useScreenMobile({ size: 992 });

  return (
    <>
      {isMobile ? (
        <Drawer showFooter={false} handleCancel={handleCancel} isVisible>
          <TeamContent onAddRole={onAddRole} handleCancel={handleCancel} />
        </Drawer>
      ) : (
        <Modal
          title="Create Team"
          showFooter={false}
          showCross
          handleCancel={handleCancel}
          padding="40px"
        >
          <TeamContent onAddRole={onAddRole} handleCancel={handleCancel} />
        </Modal>
      )}
    </>
  );
}

export default Team;